<style lang="scss" scoped>
  @import '../../../sass/variables';

  .btn-gray,
  .btn-gray:not(:disabled):not(.disabled):active {
    color: $gray-dark;
  }
</style>

<template>
  <BModal
    id="modal-action-mail-show"
    modal-class="modal-no-header-no-footer modal-width-850"
    ref="modal-action-mail-show"
    hide-header="hide-header"
    hide-footer="hide-footer"
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="hideModal()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center">
        <span>{{ __(job.name) }}</span>
        <h6 class="modal-subtitle">
          {{ mail.name }}
        </h6>
      </h4>
      <iframe
        width="100%"
        height="300"
        frameborder="0"
        :srcdoc="mail.html"
        v-if="mail.html"
      />
      <div class="modal-footer d-flex align-items-center px-20px">
        <span>{{ __('Última alteração') }}:<strong class="ml-2">{{ mail.updated_at | datetime('LD') }}</strong></span>
        <button
          class="btn btn-gray ml-auto"
          @click.prevent="openMail(mail.id)"
        >
          {{ __('Editar') }}
        </button>
      </div>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  mounted () {
    Bus.$on('showActionMail', (data) => this.openModal(data));
  },

  data: () => ({
    job: {
      name: '',
    },
    mail: {},
  }),

  methods: {
    openModal (data) {
      this.job = data.job;
      this.mail = data.actionable;

      this.$refs['modal-action-mail-show'].show();
    },

    hideModal () {
      this.$refs['modal-action-mail-show'].hide();
    },

    openMail (id) {
      window.open(`/mail/${id}`);
    },
  },
};
</script>
